import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../common/Buttons";
import PrimaryGuardian from "./PrimaryGuardian";
import SecondaryGuardian from "./SecondaryGuardian";
import GuardianWishes from "./GuardianWishes";

const Guardian = ({ next, pre, setButtonDisabled, buttonDisabled }) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(1);

  const nextTab = () => {
    setCurrentTab((pre) => (pre < 3 ? pre + 1 : 3));
  };
  const preTab = () => {
    setCurrentTab((pre) => (pre > 1 ? pre - 1 : 1));
  };
  const tabMapper = {
    1: (
      <PrimaryGuardian
        next={nextTab}
        pre={pre}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    2: (
      <SecondaryGuardian
        next={nextTab}
        pre={preTab}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    3: (
      <GuardianWishes
        next={next}
        pre={preTab}
        setButtonDisabled={setButtonDisabled}
      />
    ),
  };

  const renderTab = useMemo(() => {
    return tabMapper[currentTab];
  }, [currentTab]);

  return (
    <>
      {renderTab}
      <div
        style={{
          minWidth: "310px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <SecondaryButton
          title={t("save-and-continue")}
          bgColor="#E8D7E5"
          borderRadius="14px"
          width="180px"
          marginLeft="20px"
          border="none"
          hoverBgColor="color.magentaLight1"
          textTransform="initial"
          padding="0rem"
          height="2.7rem"
          form="form_submit"
          type="submit"
          disabled={buttonDisabled}
        />
        <LinkButton
          title={t("skip-for-now")}
          bgColor="color.transparent"
          borderRadius="14px"
          fontSize="0.8rem"
          width="100px"
          padding="0"
          marginLeft="10px"
          border="none"
          click={() => {
            if (currentTab === 1 || currentTab === 2) nextTab();
            else next();
          }}
          textTransform="initial"
        />
      </div>
    </>
  );
};

export default Guardian;
